import {GET_SEO} from '../actions/seo/type'

const initState = {title: "", noTailTitle: false, keywords: "", description: ""}
export default function(state = initState, action) {
    switch(action.type) {
        case GET_SEO:
            const data = action.payload || {}
            const {seo_title, seo_keywords, seo_desc} = data
            let noTailTitle = (seo_title && seo_title !== "")
            return {...state, title: seo_title, noTailTitle, keywords: seo_keywords, description: seo_desc}
        default:
            return {...state}
    }
}